import type { WorkEnvironment } from "../contexts/WorkEnvironmentContext";

export const WORK_ENV_MODEL_MISMATCH_MSG =
  "선택한 작업 환경과 다른 모델의 단말기입니다.";

export function applyWorkEnvironmentToParams(
  params: Record<string, string | number | boolean>,
  env: WorkEnvironment | null,
) {
  if (env?.terminalModelId) {
    params.terminalModelId = env.terminalModelId;
  }
}

export function isWorkEnvironmentModelMismatch(
  row: { terminalModelId?: number },
  env: WorkEnvironment | null,
): boolean {
  if (!env?.terminalModelId) return false;
  if (row.terminalModelId == null || row.terminalModelId === 0) return false;
  return row.terminalModelId !== env.terminalModelId;
}
